import { Icon } from '@sravni/react-design-system';

import { useAppSelector } from 'shared/lib';

import { whiteLabelAffIdSelector } from 'entities/whiteLabels';

import { FormIconConfig, DefaultFormIcons } from './FormIcon.config';
import type { TFormIcon } from './FormIcon.types';

export const FormIcon: FC<TFormIcon> = ({ stepName }) => {
  const defaultIcon = DefaultFormIcons[stepName] || null;
  const partnerId = useAppSelector(whiteLabelAffIdSelector);

  if (!partnerId) {
    return defaultIcon;
  }

  const WlIcon = FormIconConfig[partnerId]?.[stepName] || null;

  if (!WlIcon) {
    return defaultIcon;
  }

  return (
    <Icon size={20}>
      <WlIcon />
    </Icon>
  );
};
